import instance from './axiosInstance';

export const getSPIThresholds = (reqBody, options = {}, http = instance) =>
  http.get('/spi/kpi', reqBody);
export const updateCustomKPI = (reqBody, options = {}, http = instance) =>
  http.put('/spi/kpi', reqBody, options);
export const getKpiUsage = (kpiId: number, http = instance) =>
  http.get<{ inUseByAiAlerts: boolean }>(`/spi/kpi/${kpiId}/usage`);
export const deleteCustomKPI = (reqBody, options = {}, http = instance) =>
  http.delete(`/spi/kpi/${reqBody.kpiId}`, reqBody).catch((error) => {
    // Legacy KPI dialogs display error.message; preserve the server's usage warning there too.
    if (error?.response?.data?.code === 'KPI_IN_USE_BY_AI_ALERTS') {
      error.message = error.response.data.message;
    }
    throw error;
  });
export const getSelectedKPI = (reqBody, options = {}, http = instance) =>
  http.get('/spi/user/kpi', reqBody);
export const saveSelectedKPI = (reqBody, options = {}, http = instance) =>
  http.post('/spi/user/kpi', reqBody, options);
export const saveAndApplySelectedKPI = (reqBody, options = {}, http = instance) =>
  http.post('/spi/kpi/save-and-apply', reqBody, options);
export const getKpiMetaConfigs = (reqBody, options = {}, http = instance) =>
  http.get('/spi/kpi/meta-configs', reqBody);

export default getSPIThresholds;
